<div class="row" style="padding-top: 100px;">
  <div class="col-sm-1"></div>
  <div class="col-sm-10"></div>
  <div class="col-sm-1"></div>
</div>
<div class="container" style="padding-right: 50px; max-width: 93.5%;">
  <div class="row" style="margin-right: 174px;">
    <div
      class="col-md-5 pull-right hidden-xs hidden-sm"
      style="float: left !important; margin-left: -10px;"
    >
      <div class="yCmsContentSlot login-right-content-slot">
        <div class="yCmsComponent login-right-content-component">
          <div class="banner__component simple-banner">
            <a style="display: block;">
              <img
                style="
                  width: 379px;
                  height: 529px;
                  top: -13.38px;
                  left: 7.4px;
                  margin-top: 49px;
                "
                title="login image"
                alt="login image"
                src="assets/img/bg.png"
                width="20px"
                height="20px"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6" style="margin-top: 38px; margin-left: 15px;">
      <div
        class="yCmsContentSlot regist-left-content-slot js-regist-slot"
        style="margin-right: 10px; display: flex; flex-direction: column;"
      >
        <div
          class="yCmsComponent regist-left-content-component"
          style="order: 2;"
        >
          <div class="regist-section">
            <div>
              <div>
                <div>
                  <h3
                    class="register-customer"
                    style="
                      color: #373f41;
                      margin-bottom: 5px;
                      
                      font-style: normal;
                      font-weight: bold;
                      font-size: 32px;
                      line-height: 40px;
                      letter-spacing: 0.1px;
                      width: 800px;
                      height: 40px;
                      left: calc(50% - 128px / 2 - 124px);
                      top: 126px;
                    "
                  >
                    Pendaftaran Training
                  </h3>
                </div>
                <div
                  class="row"
                  style="
                    width: 750px;
                    border-bottom: 1px solid #e8e8e8;
                    margin-left: 0px;
                  "
                >
                  <p
                    style="
                      
                      font-style: normal;
                      font-weight: normal;
                      font-size: 16px;
                      line-height: 22px;
                      letter-spacing: 0.3px;
                      color: #737b7d;
                      width: 617px;
                      left: calc(50% - 617px / 2 + 120.5px);
                      top: 185px;
                      bottom: 931px;
                      margin-left: -10px;
                    "
                  >
                  Silahkan lengkapi data berikut untuk daftar training Sukanda Onelink
                  </p>
                </div>
                <div class="row" style="margin-top: 15px;">
                      <form
                        class="registerCustomerForm"
                        [formGroup]="registerCustomerForm"
                        (ngSubmit)=" onSubmit(registerCustomerForm.value)"
                      >
                        <div
                          class="row"
                          style="width: 778px; margin-bottom: 18px;"
                        >
                          <div class="col-sm-5">
                            <div
                              class="form-group"
                              style="margin: bottom 10px; position: relative;"
                            >
                              <div
                                class="form-input-container"
                                style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                "
                              >
                                <input
                                  id="picEmail"
                                  name="picEmail"
                                  formControlName="picEmail"
                                  class="form-control"
                                  placeholder="Alamat Email"
                                  type="email"
                                  style="
                                    left: 16px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  "
                                />
                                <div
                                  *ngIf="isSubmitted && f.picEmail.invalid"
                                  class="invalid"
                                >
                                  <div *ngIf="f.picEmail.errors.required">
                                    &#65121; Alamat Email harus diisi.
                                  </div>
                                  <div *ngIf="f.picEmail.errors.email">
                                    &#65121; Email harus sesuai format contoh:
                                    example@mail.com.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div
                              class="form-group"
                              style="margin: bottom 10px; position: relative;"
                            >
                              <div
                                class="form-input-container"
                                style="
                                  position: relative;
                                  margin-bottom: -8px;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #fafbfd;
                                  border-radius: 4px;
                                "
                              >
                                <input
                                  id="date"
                                  name="date"
                                  formControlName="date"
                                  class="form-control"
                                  placeholder="Pilih Jadwal Training"
                                  type="date"
                                  style="
                                    left: 16px;
                                    right: 16px;
                                    top: 11px;
                                    bottom: 11px;

                                    font-style: normal;
                                    font-weight: normal;
                                    font-size: 14px;
                                    line-height: 20px;

                                    /* identical to box height, or 143% */
                                    display: flex;
                                    align-items: center;
                                    letter-spacing: 0.2px;
                                    background-color: #fafbfd;
                                    color: #a0a3bd;
                                  "
                                />
                                <div
                                  *ngIf="isSubmitted && f.date.invalid"
                                  class="invalid"
                                >
                                  <div *ngIf="f.date.errors.required">
                                    &#65121; Jadwal Training harus diisi.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" style="width: 849px;">
                          <div class="col-sm-5">
                            <p
                              class="tx-medium"
                              style="
                                font-size: 12px;
                                color: #737b7d;
                                line-height: 1.42857143;
                                margin-bottom: none;
                                box-sizing: border-box;
                                
                              "
                            >
                              Dengan melanjutkan ke langkah berikutnya, Anda
                              menyetujui semua
                              <a
                                class="terms-and-conditions-link"
                                [routerLink]="['/syarat&ketentuan']"
                                style="
                                  color: #3c64b1;
                                  text-decoration: none;
                                  
                                "
                                >syarat &amp; ketentuan</a
                              >
                              serta
                              <a
                                class="terms-and-conditions-link"
                                [routerLink]="['/kebijakan-privasi']"
                                style="
                                  color: #3c64b1;
                                  text-decoration: none;
                                  
                                "
                                >kebijakan privasi</a
                              >
                              yang berlaku.
                            </p>
                          </div>
                          <div class="col-sm-6">
                            <div *ngIf="buttonSubmit">
                              <button
                                type="submit"
                                style="
                                  color: #fff;
                                  background-color: #3c64b1;
                                  left: 0px;
                                  right: 0px;
                                  top: 0px;
                                  bottom: 0px;

                                  background: #3c64b1;

                                  /* Elevasi 3 */
                                  box-shadow: 4px 8px 24px rgba(0, 0, 0, 0.1);
                                  border-radius: 4px;
                                "
                                [disabled]="registerCustomerForm.invalid"
                                class="btn btn-block contained js-regist-check-2fa-flag"
                              >
                                Daftar Training
                              </button>
                            </div>
                            <div *ngIf="buttonLoading">
                              <button class="btn btn-primary" disabled>
                                <span
                                  class="spinner-border spinner-border-sm"
                                ></span>
                                Loading..
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="yCmsComponent regist-left-content-component reorder-containers"
            style="order: 1;"
          >
            <div
              class="banner__component simple-banner"
              style="width: 100%; height: auto;"
            ></div>
          </div>
        </div>
      </div>
    </div>
</div>
